import React, { FC, useEffect, useState } from 'react';

import TemplateModal from 'components/common/modals/TemplateModal';
import Button from 'components/common/ui-kit/Button';
import { InputV2 } from 'components/common/ui-kit/Input/view';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import terms from 'i18n';
import { User } from 'models/enrollee';
import { UserRole } from 'models/user';
import { hideModal } from 'redux/actions';
import { enrolleesApi } from 'redux/api/questionnaire/enrollees-api';
import { useUpdateEducationResultsMutation } from 'redux/api/questionnaire/questionnaire-api';
import { selectUserRole } from 'redux/selectors';
import {
  selectCurrentQuestionnaire,
  selectCurrentApplication,
} from 'redux/selectors/staff/applications';
import { staffApplicationsSlice } from 'redux/slices/staff/staffApplicationsSlice';
import { supportQuestionnaireSlice } from 'redux/slices/staff/supportQuestionnaireSlice';

const EditDirectionNameModal: FC = () => {
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(hideModal());

  const application = useAppSelector(selectCurrentApplication);
  const questionnaire = useAppSelector(selectCurrentQuestionnaire);
  const [updateStatistics, { isLoading }] = useUpdateEducationResultsMutation();

  const [triggerGetEnrollee] = enrolleesApi.useLazyGetByUserIdQuery();

  const educationProfileId = application?.educationProfileId;
  const userId = application?.userId;

  const educationInfo = questionnaire?.educationalInformationForm?.find(
    edu => edu.educationalInformationDraftId === educationProfileId
  );

  const [codeDirection, setCodeDirection] = useState('');
  const [nameDirection, setNameDirection] = useState('');

  const role = useAppSelector(selectUserRole);
  const isSupport = role === UserRole.SUPPORT;

  useEffect(() => {
    if (educationInfo) {
      setCodeDirection(educationInfo.directionCode ?? '');
      setNameDirection(educationInfo.directionName ?? '');
    }
  }, [educationInfo]);

  const handleSave = async () => {
    if (!educationProfileId || !userId) {
      console.error('Missing required ids');
      return;
    }

    try {
      await updateStatistics({
        id: educationProfileId, // educationalInformationDraftId
        directionCode: codeDirection,
        directionName: nameDirection,
      }).unwrap();

      if (userId) {
        await triggerGetEnrollee(userId).unwrap();
      }
      const freshQuestionnaire = await triggerGetEnrollee(userId).unwrap();

      if (isSupport) {
        dispatch(
          supportQuestionnaireSlice.actions.setCurrentQuestionnaire(
            freshQuestionnaire
          )
        );
      } else {
        dispatch(
          staffApplicationsSlice.actions.setCurrentApplication({
            application: application!,
            questionnaire: freshQuestionnaire,
            user: application?.userId
              ? ({ id: application.userId } as User)
              : undefined,
          })
        );
      }
      closeModal();
    } catch (error) {
      console.error('error:', error);
    }
  };

  if (!application || !questionnaire) {
    return (
      <TemplateModal title="Редактировать">
        <div>Загрузка...</div>
      </TemplateModal>
    );
  }

  return (
    <TemplateModal title="Редактировать">
      <div className="graduate-marks-modal">
        <div className="graduate-group">
          <label>{terms.DIRECTION_CODE}</label>
          <InputV2
            type="text"
            maxLength={10}
            value={codeDirection}
            onChange={e => {
              const raw = e.target.value;
              if (/^[\d.]*$/.test(raw)) {
                setCodeDirection(raw);
              }
            }}
          />
          <label>{terms.DIRECTION_NAME}</label>
          <InputV2
            type="text"
            maxLength={255}
            value={nameDirection}
            onChange={e => setNameDirection(e.target.value)}
          />
        </div>
        <div className="action">
          <Button theme="success" onClick={handleSave} disabled={isLoading}>
            {isLoading ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default EditDirectionNameModal;
